/* Ctrl Zed — hardcoded EN/ES language layer (no Translate app).
   English is the server-rendered base; Spanish is applied in the browser.
   Language: ?lang= param > cz_lang cookie > browser language.
   Spanish text lives in assets/cz-es-*.json; header.liquid lists the files for each page in window.CZ_FILES.
   File format: { "replace": {selector: html}, "dict": {english: spanish}, "patterns": [[regex, replacement]],
                  "articles": {handle: {excerpt}}, "more": true } */
(function () {
  'use strict';

  var html = document.documentElement;

  /* Reviews carousel heading: Judge.me clamps it to one line, so a longer title gets cut off and its
     second line spills over the star rating. Let it wrap, add space below it, and use a smaller size
     on phones. */
  (function () {
    var st = document.createElement('style');
    st.setAttribute('data-cz', 'jdgm-title');
    st.textContent = '.jdgm-cards-carousel .jdgm-title{display:block!important;-webkit-line-clamp:unset!important;line-clamp:unset!important;-webkit-box-orient:initial!important;height:auto!important;max-height:none!important;overflow:visible!important;text-overflow:clip!important;white-space:normal!important;margin-bottom:8px!important}' +
      '@media (max-width:749px){.jdgm-cards-carousel .jdgm-title{font-size:26px!important;line-height:1.2!important}}';
    document.head.appendChild(st);
  })();

  var BLOCKS = 'h1,h2,h3,h4,h5,h6,p,li,a,button,label,span,summary,dt,dd,td,th,figcaption,blockquote,small,strong,em,b,i,legend,caption,option,div';
  var ATTRS = ['placeholder', 'aria-label', 'alt', 'title'];
  var MONTHS = {
    January: 'enero', February: 'febrero', March: 'marzo', April: 'abril', May: 'mayo', June: 'junio',
    July: 'julio', August: 'agosto', September: 'septiembre', October: 'octubre', November: 'noviembre', December: 'diciembre',
    Jan: 'ene', Feb: 'feb', Mar: 'mar', Apr: 'abr', Jun: 'jun', Jul: 'jul', Aug: 'ago', Sep: 'sept', Oct: 'oct', Nov: 'nov', Dec: 'dic'
  };

  var DICT = { 'Customers are saying': 'Lo que dicen nuestros clientes' };
  var REPLACE = [];
  var PATTERNS = [];
  var ARTICLES = {};
  var has = Object.prototype.hasOwnProperty;

  function setLang(l) {
    try { document.cookie = 'cz_lang=' + l + ';path=/;max-age=31536000;samesite=lax'; } catch (e) {}
  }

  function getLang() {
    try {
      var p = new URLSearchParams(location.search).get('lang');
      if (p === 'en' || p === 'es') { setLang(p); return p; }
    } catch (e) {}
    try {
      var m = document.cookie.match(/(?:^|;\s*)cz_lang=(en|es)/);
      if (m) return m[1];
    } catch (e) {}
    var nav = (navigator.language || navigator.userLanguage || 'en').toLowerCase();
    return nav.indexOf('es') === 0 ? 'es' : 'en';
  }

  var lang = getLang();

  function norm(s) { return (s || '').replace(/\s+/g, ' ').trim(); }

  function reveal() { html.classList.remove('cz-pending'); }

  /* Reviews carousel heading: Judge.me sometimes leaves its cards-carousel title empty, and it can
     fill in the English title late (after the page was translated). Keep it filled in, in the
     visitor's language. */
  function fillReviewTitle() {
    var en = (window.jdgmSettings && window.jdgmSettings.cards_carousel_title) || 'Customers are saying';
    var want = lang === 'es' ? 'Lo que dicen nuestros clientes' : en;
    document.querySelectorAll('.jdgm-cards-carousel .jdgm-title').forEach(function (h) {
      var cur = norm(h.textContent);
      if (!cur || (lang === 'es' && cur === norm(en))) h.textContent = want;
    });
  }

  function scheduleReviewTitle() {
    fillReviewTitle();
    [500, 1500, 3000, 6000, 10000, 15000].forEach(function (ms) { setTimeout(fillReviewTitle, ms); });
    try {
      var mo = new MutationObserver(fillReviewTitle);
      mo.observe(document.body, { childList: true, subtree: true, characterData: true });
      setTimeout(function () { mo.disconnect(); }, 20000);
    } catch (e) {}
  }

  /* ---------- loading ---------- */

  function load(url) {
    return fetch(url, { cache: 'no-cache' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (data) {
        if (!data) return null;
        if (data.more) {
          var next = url.replace(/(?:-(\d+))?\.json(\?.*)?$/, function (_, n) {
            return '-' + ((parseInt(n || '1', 10)) + 1) + '.json';
          });
          return load(next).then(function (rest) { return [data].concat(rest || []); });
        }
        return [data];
      });
  }

  function merge(d) {
    if (!d) return;
    if (d.dict) for (var k in d.dict) if (has.call(d.dict, k)) DICT[norm(k)] = d.dict[k];
    if (d.replace) for (var s in d.replace) if (has.call(d.replace, s)) REPLACE.push([s, d.replace[s]]);
    if (d.patterns) d.patterns.forEach(function (p) {
      try { PATTERNS.push([new RegExp(p[0]), p[1]]); } catch (e) {}
    });
    if (d.articles) for (var h in d.articles) if (has.call(d.articles, h)) ARTICLES[h] = d.articles[h];
  }

  /* ---------- translating ---------- */

  function lookup(text) {
    var key = norm(text);
    if (!key) return null;
    if (has.call(DICT, key)) return DICT[key];
    for (var i = 0; i < PATTERNS.length; i++) {
      if (PATTERNS[i][0].test(key)) return key.replace(PATTERNS[i][0], PATTERNS[i][1]);
    }
    return null;
  }

  function skip(el) {
    return el.closest('script,style,svg,noscript,[data-cz-lang-select],[data-cz-skip],[data-cz-done]');
  }

  function translateBlock(el) {
    if (skip(el)) return;
    var val = lookup(el.textContent);
    if (val === null) return;
    if (/<[a-z][\s\S]*>/i.test(val)) {
      el.innerHTML = val;
    } else if (el.children.length === 0) {
      el.textContent = val;
    } else {
      var texts = [];
      var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      var n;
      while ((n = w.nextNode())) if (n.nodeValue.trim()) texts.push(n);
      if (texts.length !== 1) return;
      texts[0].nodeValue = texts[0].nodeValue.replace(texts[0].nodeValue.trim(), val);
    }
    el.setAttribute('data-cz-done', '');
  }

  function translateTextNodes(root) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var batch = [];
    var n;
    while ((n = w.nextNode())) {
      var p = n.parentElement;
      if (!p || skip(p)) continue;
      var raw = n.nodeValue;
      if (!raw.trim()) continue;
      var val = lookup(raw);
      if (val !== null && !/<[a-z][\s\S]*>/i.test(val)) batch.push([n, raw.replace(raw.trim(), val)]);
    }
    batch.forEach(function (b) { b[0].nodeValue = b[1]; });
  }

  function translateAttrs(root) {
    var sel = '[' + ATTRS.join('],[') + ']';
    var els = Array.prototype.slice.call(root.querySelectorAll(sel));
    if (root.matches && root.matches(sel)) els.push(root);
    els.forEach(function (el) {
      ATTRS.forEach(function (a) {
        if (!el.hasAttribute(a)) return;
        var val = lookup(el.getAttribute(a));
        if (val !== null) el.setAttribute(a, val);
      });
    });
  }

  function translateDates(root) {
    root.querySelectorAll('time').forEach(function (t) {
      if (t.hasAttribute('data-cz-done')) return;
      var s = norm(t.textContent);
      var m = s.match(/^([A-Z][a-z]+) (\d{1,2}), (\d{4})$/);
      if (m && MONTHS[m[1]]) {
        t.textContent = parseInt(m[2], 10) + ' de ' + MONTHS[m[1]] + ' de ' + m[3];
        t.setAttribute('data-cz-done', '');
      }
    });
  }

  function translateExcerpts(root) {
    root.querySelectorAll('[class*="excerpt"]').forEach(function (ex) {
      if (ex.hasAttribute('data-cz-done')) return;
      var a = null;
      var card = ex.parentElement;
      for (var i = 0; card && i < 6 && !a; i++) {
        a = card.querySelector('a[href*="/blogs/"]');
        if (!a) card = card.parentElement;
      }
      if (!a) return;
      var handle = a.getAttribute('href').split('?')[0].split('#')[0].replace(/\/+$/, '').split('/').pop();
      var info = ARTICLES[handle];
      if (!info || !info.excerpt) return;
      var orig = norm(ex.textContent);
      var es = info.excerpt;
      if (/(\.\.\.|…)$/.test(orig) && es.length > orig.length) {
        es = es.slice(0, Math.max(20, orig.length - 3)).replace(/\s+\S*$/, '') + '...';
      }
      ex.textContent = es;
      ex.setAttribute('data-cz-done', '');
    });
  }

  function translate(root, full) {
    if (full) {
      REPLACE.forEach(function (r) {
        var els;
        try { els = document.querySelectorAll(r[0]); } catch (e) { return; }
        els.forEach(function (el) {
          if (el.hasAttribute('data-cz-done')) return;
          el.innerHTML = r[1];
          el.setAttribute('data-cz-done', '');
        });
      });
    }
    translateExcerpts(root);
    translateDates(root);
    var blocks = Array.prototype.slice.call(root.querySelectorAll(BLOCKS));
    if (root.matches && root.matches(BLOCKS)) blocks.unshift(root);
    for (var i = blocks.length - 1; i >= 0; i--) translateBlock(blocks[i]);
    translateTextNodes(root);
    translateAttrs(root);
  }

  function observe() {
    var pending = [];
    var timer = null;
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1) pending.push(n);
          else if (n.nodeType === 3 && n.parentElement) pending.push(n.parentElement);
        });
      });
      if (!pending.length || timer) return;
      timer = setTimeout(function () {
        var list = pending;
        pending = [];
        timer = null;
        list.forEach(function (el) { if (el.isConnected) translate(el, false); });
      }, 60);
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* Product pages: sections/mobile-buybox.liquid shows the first sentence of the description under the
     price through CSS (::after content). Rebuild it from the Spanish description. */
  function productBlurb() {
    var desc = document.querySelector('.product-description[data-cz-done]');
    var row = document.querySelector('.product-info > .product-price-row');
    if (!desc || !row) return;
    var cur = getComputedStyle(row, '::after').content;
    if (!cur || cur === 'none' || cur === 'normal') return;
    var p = desc.querySelector('p') || desc;
    var first = norm(p.textContent).split('. ')[0].trim();
    if (!first) return;
    if (first.length > 170) first = first.slice(0, 167).replace(/\s+\S*$/, '') + '...';
    else if (!/[.!?…]$/.test(first)) first += '.';
    var st = document.createElement('style');
    st.setAttribute('data-cz', 'blurb');
    st.textContent = '.product-info > .product-price-row::after{content:"' +
      first.replace(/\\/g, '\\\\').replace(/"/g, '\\\"') + '" !important;}';
    document.head.appendChild(st);
  }

  /* Browser tab title: Spanish version of known page titles; product and article pages use the
     translated page heading. */
  var TITLES = {
    'Korean PDRN Skincare — Salmon DNA Serums & More | Ctrl Zed': 'Cuidado de la piel coreano con PDRN — Sérums de ADN de salmón y más | Ctrl Zed',
    'FAQ — Shipping, Returns & PDRN Skincare | Ctrl Zed': 'Preguntas frecuentes — Envíos, devoluciones y PDRN | Ctrl Zed',
    'About Ctrl Zed': 'Sobre Ctrl Zed',
    'Contact Ctrl Zed': 'Contacto | Ctrl Zed',
    'Your Shopping Cart – Ctrl Zed': 'Tu carrito | Ctrl Zed',
    'Products – Ctrl Zed': 'Productos | Ctrl Zed'
  };

  function translateTitle() {
    var t = norm(document.title);
    if (has.call(TITLES, t)) { document.title = TITLES[t]; return; }
    if (/^\/(products|blogs)\//.test(location.pathname)) {
      var h = document.querySelector('h1');
      if (h && norm(h.textContent)) document.title = norm(h.textContent) + ' | Ctrl Zed';
    }
  }

  /* ---------- switcher ---------- */

  function initSwitch() {
    document.querySelectorAll('[data-cz-lang-select]').forEach(function (sel) {
      sel.value = lang;
      sel.addEventListener('change', function () {
        var v = sel.value === 'es' ? 'es' : 'en';
        setLang(v);
        var url = new URL(location.href);
        url.searchParams.delete('lang');
        location.href = url.toString();
      });
    });
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(scheduleReviewTitle);

  if (lang !== 'es') {
    reveal();
    ready(initSwitch);
    return;
  }

  html.setAttribute('lang', 'es');
  var files = window.CZ_FILES || [];
  var safety = setTimeout(reveal, 3000);

  Promise.all(files.map(load)).then(function (results) {
    results.forEach(function (parts) { (parts || []).forEach(merge); });
    ready(function () {
      try {
        translate(document.body, true);
        productBlurb();
        translateTitle();
        observe();
      } finally {
        clearTimeout(safety);
        reveal();
        initSwitch();
      }
    });
  });
})();